import http from '../http'
import * as types from '../mutation-types';

export const state = {
    status: '',
    certifications: null,
};

export const getters = {
    loadStatus: state => state.status,
    certifications: state => state.certifications
};

export const mutations = {
    /** LOAD */
    [types.LOAD_CERTIFICATIONS_LOADING](state) {
        state.status = 'loading'
    },
    [types.LOAD_CERTIFICATIONS_SUCCESS](state, {data, meta}) {
        state.status = 'success'
        state.certifications = data
    },
    [types.LOAD_CERTIFICATIONS_ERROR](state) {
        state.status = 'error'
    }
};

export const actions = {
    load({commit}) {
        return new Promise((resolve, reject) => {
            commit(types.LOAD_CERTIFICATIONS_LOADING);
            http.get('certifications').then(({data}) => {
                commit(types.LOAD_CERTIFICATIONS_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.LOAD_CERTIFICATIONS_ERROR)
                reject(response.data)
            })
        })
    }
};
